export default __webpack_public_path__ + "static/imgHomepng-d42f91a51d8dc016b113341f551deff2.png";